<template>
	<div class="app">
		<DefaultHeader/>
		<div class="app-body">
			<AppSidebar fixed>
				<SidebarHeader/>
				<SidebarForm/>
				<SidebarNav :navItems="navItems"></SidebarNav>
				<SidebarFooter/>
				<SidebarMinimizer/>
			</AppSidebar>
			<main class="main">
				<b-breadcrumb>
					<b-breadcrumb-item v-for="item in list" :to="item.to">{{item.text}}</b-breadcrumb-item>
				</b-breadcrumb>
				<div class="container-fluid">
					<router-view></router-view>
				</div>
			</main>
			<AppAside fixed>
				<!--aside-->
				<DefaultAside/>
			</AppAside>
		</div>
		<DefaultFooter/>
	</div>
</template>

<script>
	import nav from '@/_nav'
	import navTec from '@/_navTec'
	import {
		Sidebar as AppSidebar,
		SidebarFooter,
		SidebarForm,
		SidebarHeader,
		SidebarMinimizer,
		SidebarNav,
		Aside as AppAside,
		Breadcrumb
	} from '@coreui/vue'
	import DefaultAside from './DefaultAside'
	import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
	import DefaultHeader from './DefaultHeader'
	import DefaultFooter from './DefaultFooter'
	import SPCSideBar from "../components/SPCSideBar";
	import {mapState} from "vuex";
	import {
		WEB_MODULES_CDT,
		WEB_MODULES_CLIENT_PRODUCTS,
		WEB_MODULES_CONTRACTS,
		WEB_MODULES_INCIDENTS, WEB_MODULES_INVOICES,
		WEB_MODULES_MAINTENANCE_CONTRACTS, WEB_MODULES_OPPORTUNITIES, WEB_MODULES_PROFILE, WEB_MODULES_QUOTES,
		WEB_MODULES_TICKETS,
		WEB_MODULES_WORKSHOP_INCIDENTS
	} from "../constans";

	export default {
		name: 'DefaultContainer',
		components: {
			SPCSideBar,
			AppSidebar,
			AppAside,
			Breadcrumb,
			DefaultAside,
			DefaultHeaderDropdownAccnt,
			SidebarForm,
			SidebarFooter,
			SidebarHeader,
			SidebarNav,
			SidebarMinimizer,
			DefaultFooter,
			DefaultHeader
		},
		data() {
			return {
				nav: nav.items,
				navTec:nav.items,
				breadCrumb: [],
				userModules: [],
				user:''
			}
		},
		mounted() {
			this.userModules = JSON.parse(localStorage.getItem('userModules'));
			this.user = JSON.parse(this.$store.getters.user);
		},
		computed: {
			/*...mapState({
				userModules: state => state.userModules
			}),*/
			name() {
				return this.$route.name
			},
			list() {
				let breadcrumbList = [];
				let items = this.$route.matched.filter((route) => route.name || route.meta.label);
				var that = this;

				items.map(function (route, index) {
					let item = {
						text: route.meta.label ? route.meta.label : route.name
					};

					if (route.bcDynamic) {
						item.to = {name: route.name, params: {id: route.params.id}};
					} else if (route.name === 'AccountRoot' && that.$store.state.accountSelected) {
						item.to = {name: 'AccountDetail', params: {id: that.$store.state.accountSelected.accountID}};
					} else if (route.name === 'AccountDetail' && that.$store.state.accountSelected) {
						item.text = that.$store.state.accountSelected.alias;
					} else {
						item.to = {name: route.name};
					}

					breadcrumbList.push(item)
				});
				return breadcrumbList;
			},
			navItems() {
				if (this.$store.state.accountSelected !== '') {
					let itemChildren = [
						{
							name: 'Detalle',
							icon: 'fa fa-arrow-right',
							url: '/accounts/account/detail/' + this.$store.getters.accountSelected.accountID
						}
					];

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_PROFILE)) {
						itemChildren.push({
							name: 'Actualizar',
							icon: 'fa fa-pencil-square-o',
							url: '/accounts/account/update/'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_INCIDENTS)) {
						itemChildren.push({
							name: 'Casos',
							icon: 'fa fa-book',
							url: '/accounts/account/incidents'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_WORKSHOP_INCIDENTS)) {
						itemChildren.push({
							name: 'Casos de Taller',
							icon: 'fa fa-building',
							url: '/accounts/account/workshop-incidents'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_CDT)) {
						itemChildren.push({
							name: "CDT'S",
							icon: 'fa fa-briefcase',
							url: '/accounts/account/work-projects'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_MAINTENANCE_CONTRACTS)) {
						itemChildren.push({
							name: 'C. Mantenimiento',
							icon: 'fa fa-wrench',
							url: '/accounts/account/maintenance-contracts'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_CONTRACTS)) {
						itemChildren.push({
							name: 'C. Monitoreo',
							icon: 'fa fa-file-video-o',
							url: '/accounts/account/contracts'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_QUOTES)) {
						itemChildren.push({
							name: 'Cotizaciones',
							icon: 'fa fa-file-text-o',
							url: '/accounts/account/quotes'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_CLIENT_PRODUCTS)) {
						itemChildren.push({
							name: 'Equipos',
							icon: 'fa fa-video-camera',
							url: '/accounts/account/client-products'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_INVOICES)) {
						itemChildren.push({
							name: 'Facturas',
							icon: 'fa fa-file-text',
							url: '/accounts/account/invoices'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_TICKETS)) {
						itemChildren.push({
							name: 'Tickets',
							icon: 'fa fa-ticket',
							url: '/accounts/account/tickets'
						});
					}

					if (this.userModules.some(userModule => userModule.WebModule === WEB_MODULES_TICKETS)) {
						itemChildren.push({
							name: 'Zonificación',
							icon: 'fa fa-globe',
							url: '/accounts/account/zoning'
						});
					}

					let items = [
						{
							name: 'Dashboard',
							url: '/dashboard',
							icon: 'icon-speedometer',
						},
						{
							name: 'Sucursales',
							url: '/accounts',
							icon: 'icon-layers',
						},
						{
							name: 'Proyectos',
							url: '/projects',
							icon: 'icon-folder',
						},
						{
							name: 'Mi Cuenta',
							icon: 'fa fa-newspaper-o',
							url: '/accounts/account/detail/' + this.$store.getters.accountSelected.accountID,
							children: itemChildren
						},
					]

					items.push({
							name: 'Mi Perfil',
							icon: 'icon-user',
							url: '/auth/change-password',
							children: [
								{
									name: 'Detalle',
									url: '/auth/user-detail',
									icon: 'icon-puzzle',
								},
								{
									name: 'Cambiar Contraseña',
									url: '/auth/change-password',
									icon: 'icon-puzzle',
								}
							]
						},
						{
							name: 'Cerrar Sesión',
							url: '/logout',
							icon: 'icon-logout'
						},)

					return items;
				}
				if(this.user.tipoUsuario == '100000000'){
					return navTec.items;
				}
				else{
					return nav.items;
				}
			}
		}
	}
</script>
